export enum SurveyQuestionType {
    Heading = 4,
    Paragraph = 5,
    OpenEndedOneLine = 6,
    SingleChoice = 0,
    MultipleChoice = 1,
    OpenEndedTextArea = 2,
    Matrix = 3
}